document.querySelectorAll('.key-ingredients__collage').forEach((collage) => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          collage.classList.add('in-view');
          observer.disconnect();
        }
      });
    },
    { threshold: 0.15 }
  );
  observer.observe(collage);

  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const wrappers = Array.from(collage.querySelectorAll('.key-ingredients__card-wrapper'));

  const setHovered = (activeIndex) => {
    wrappers.forEach((wrapper, i) => {
      wrapper.classList.remove('is-hovered', 'is-pushed-left', 'is-pushed-right');
      if (i === activeIndex) {
        wrapper.classList.add('is-hovered');
      } else if (i < activeIndex) {
        wrapper.classList.add('is-pushed-left');
      } else {
        wrapper.classList.add('is-pushed-right');
      }
    });
  };

  const clearHovered = () => {
    wrappers.forEach((wrapper) => {
      wrapper.classList.remove('is-hovered', 'is-pushed-left', 'is-pushed-right');
    });
  };

  if (hoverCapable) {
    wrappers.forEach((wrapper, i) => {
      wrapper.addEventListener('mouseenter', () => setHovered(i));
      const button = wrapper.querySelector('button');
      if (button) {
        button.addEventListener('focus', () => {
          if (button.matches(':focus-visible')) setHovered(i);
        });
      }
    });

    collage.addEventListener('mouseleave', clearHovered);
  } else {
    // Touch: first tap previews (fans the card out), a second tap on the
    // already-active card opens its modal.
    let activeIndex = null;

    wrappers.forEach((wrapper, i) => {
      const button = wrapper.querySelector('button');
      if (!button) return;
      button.addEventListener(
        'click',
        (event) => {
          if (activeIndex !== i) {
            event.preventDefault();
            event.stopPropagation();
            activeIndex = i;
            setHovered(i);
          }
        },
        true
      );
    });

    document.addEventListener('click', (event) => {
      if (!collage.contains(event.target)) {
        activeIndex = null;
        clearHovered();
      }
    });
  }
});

document.addEventListener('input', (event) => {
  const input = event.target.closest('.key-ingredients__search-input');
  if (!input) return;

  const collage = input.closest('.key-ingredients__header').nextElementSibling;
  if (!collage || !collage.classList.contains('key-ingredients__collage')) return;

  const query = input.value.trim().toLowerCase();
  const cards = collage.querySelectorAll('.key-ingredients__card');
  let visibleCount = 0;

  cards.forEach((card) => {
    const name = card.getAttribute('data-ingredient-name') || '';
    const matches = name.includes(query);
    card.closest('.key-ingredients__card-wrapper').style.display = matches ? '' : 'none';
    if (matches) visibleCount += 1;
  });

  if (visibleCount === 0) {
    collage.setAttribute('data-no-results', '');
  } else {
    collage.removeAttribute('data-no-results');
  }
});
